<style>

.date{
  border: 1px rgba(0,0,0,0) solid;
  padding: 10px;
  text-align: center;
}
.sel{
  border: 1px rgba(0,0,0,1) solid;
  background-color: rgba(0,0,0,0.7);
  color: white;
}

</style>

{#each allDates as item}
<div class="date {item == selD ? 'sel' : ''} " on:click="{ () => uSelD(item) }">{item}</div>
{/each}


<script>

import { createEventDispatcher } from 'svelte';
const dispatch = createEventDispatcher();

export let date = "DD";
export let month = "MM";
export let year = "YYYY";

let selD = 0;
let allDates = [];

let datesPerMonth = [ 31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31, ];


$:{
  if (month || year) {
    setupDates();
  }
}


function setupDates() {
  if (month == -1 || month == "MM") return;
  
  // start with all dates
  let datesPerMonthRange = datesPerMonth[month - 1];
  
  let curYear = new Date().getFullYear() - 18;
  if ( parseInt(year) == curYear ) {
    
    let curMonth = new Date().getMonth() + 1;
    if ( parseInt(month) == curMonth) {
      
      // if we get here, we need to limit the amount of dates that are selectable
      datesPerMonthRange = new Date().getDate();
      
    }
    
  }
  
  allDates = [];
  for (let i = 1; i <= datesPerMonthRange; i++) {
    allDates.push(i);
  }
}


function uSelD(i) {
  selD = i;
  done();
}


function done() {
  if (selD != 0) date = selD;
  dispatch("changed");
}


</script>